<template>
    <li class="sidebar-item" @click="expandSidebar = true"
        v-if="useCheckPermission(item.permission).hasPermission === true">
        <router-link :to="{ name: item.name }" v-if="!item.dropdown && item.new === true"
            class="sidebar-link link-body-emphasis" :class="'submenu' + item.level">
            <i :class="item.iconClass" class="fa-fw me-1"></i>
            <span>{{ item.label }}</span>
        </router-link>

        <a :href="`/${item.link}`" v-if="!item.dropdown && item.new === false" class="sidebar-link link-body-emphasis"
            :class="'submenu' + item.level">
            <i :class="item.iconClass" class="fa-fw"></i>
            <span>{{ item.label }}</span>
        </a>

        <router-link :to="{ name: item.name }" v-if="item.dropdown && item.new === true"
            class="sidebar-link link-body-emphasis collapsed" :class="'submenu' + item.level" data-bs-toggle="collapse"
            :data-bs-target="'#' + item.name" :aria-expanded="!isCollapsed ? 'true' : 'false'" :aria-controls="item.id"
            @click="handleClick">
            <i :class="item.iconClass" class="fa-fw"></i>
            <span>{{ item.label }}</span>
        </router-link>
        <ul v-if="item.dropdown" :id="item.name" class="sidebar-dropdown list-unstyled collapse">
            <SidebarItem v-for="(subItem, index) in item.dropdown" :key="index" :item="subItem">
            </SidebarItem>
        </ul>
    </li>
</template>

<script setup>
import {
    defineProps,
    inject, ref
} from 'vue';

import { useCheckPermission } from '@/composables/useCheckPermission';
const isCollapsed = ref(false);
const expandSidebar = inject('expandSidebar');
const props = defineProps(['item', 'isCollapsed']);


const handleClick = (e) => {
    const element = e.target.closest('a')
    const sidebarDropdowns = document.querySelectorAll('.sidebar-dropdown');
    sidebarDropdowns.forEach(dropdown => {
        if (dropdown.id !== props.item.id && !dropdown.contains(element)) {
            dropdown.classList.remove('show');
        }
    });

    const sidebarlinks = document.querySelectorAll('.sidebar-link');
    sidebarlinks.forEach(link => {
        if (link.id !== props.item.id && !link.contains(element)) {
            link.classList.add('collapsed');
        }
    });
};


</script>

<style>
/* Estilo para el primer nivel activo */
.router-link-active {
    background-color: #408c68 !important;
    border-left: 3px solid #116f43 !important;
}

.sidebar-dropdown .router-link-active {
    background-color: transparent !important;
}

/* Estilo para los submenús activos */
.sidebar-dropdown .router-link-exact-active {
    color: var(--bs-success-text-emphasis)!important;
    background-color: #198754
}

.submenu span {
    padding-left: 2px !important;
}

.sidebar-icon {
    text-align: center;
    width: 100%;
}
</style>
